import { styled } from "styletron-react";

const FormWrapper = styled("div", {
  maxWidth: "420px"
});

export default FormWrapper;
